import { NgModule } from '@angular/core';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { faCcAmazonPay, faFacebook, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';

import { faCirclePlay, faMessage, faTrashCan, faClock } from '@fortawesome/free-regular-svg-icons';

import {
	faArrowLeft,
	faArrowRight,
	faArrowRightLong,
	faArrowUpRightFromSquare,
	faBan,
	faBars,
	faBell,
	faCheck,
	faCircleXmark,
	faCreditCard,
	faDeleteLeft,
	faDesktop,
	faExclamationCircle,
	faExclamationTriangle,
	faExternalLink,
	faFileInvoice,
	faFish,
	faImage,
	faImages,
	faLocationArrow,
	faLock,
	faMobile,
	faNewspaper,
	faPause,
	faPencil,
	faPercent,
	faPlay,
	faPlus,
	faRightFromBracket,
	faSearch,
	faSquareXmark,
	faStar,
	faTags,
	faTimes,
	faTrash,
	faTv,
	faUser
} from '@fortawesome/free-solid-svg-icons';
import {
	faAngleDoubleLeft,
	faAngleDoubleRight,
	faAngleLeft,
	faAngleRight,
	faCameraMovie,
	faQuestionSquare,
	faHourglassClock,
	faLink,
	faLoader,
	faPuzzlePiece,
	faUserXmark,
	faEye,
	faEyeSlash,
	faSquareUser,
} from '@fortawesome/pro-solid-svg-icons';

@NgModule({
	exports: [
		FontAwesomeModule
	]
})
export class IconModule {

	constructor(library: FaIconLibrary) {

		library.addIcons(
			faAngleDoubleLeft,
			faAngleDoubleRight,
			faAngleLeft,
			faAngleRight,
			faArrowLeft,
			faQuestionSquare,
			faArrowRight,
			faArrowRightLong,
			faArrowUpRightFromSquare,
			faBan,
			faBars,
			faUserXmark,
			faBell,
			faCameraMovie,
			faCcAmazonPay,
			faCheck,
			faCirclePlay,
			faClock,
			faCreditCard,
			faDeleteLeft,
			faDesktop,
			faExclamationCircle,
			faExclamationTriangle,
			faExternalLink,
			faFacebook,
			faSquareUser,
			faCircleXmark,
			faFileInvoice,
			faLoader,
			faFish,
			faHourglassClock,
			faImage,
			faImages,
			faInstagram,
			faLink,
			faLocationArrow,
			faLock,
			faMessage,
			faMobile,
			faNewspaper,
			faPause,
			faPencil,
			faPlay,
			faPlus,
			faPercent,
			faPuzzlePiece,
			faRightFromBracket,
			faSearch,
			faSquareXmark,
			faStar,
			faTags,
			faTimes,
			faTrash,
			faTrashCan,
			faTv,
			faUser,
			faYoutube,
			faEye,
			faEyeSlash
		);
	}
}